import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";
import { FilterSelectBox } from "./styles.purchaseOrderListDesktop";

const FilterDateTrigger = forwardRef(({ value, onClick }, ref) => (
  <FilterSelectBox ref={ref} onClick={onClick} role="button" tabIndex={0}>
    <span>{value || "Select date"}</span>
    <ChevronDown size={16} />
  </FilterSelectBox>
));

FilterDateTrigger.displayName = "FilterDateTrigger";

export default FilterDateTrigger;
